import React from "react";
import { useState, useRef, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "../../../Components/InputField";
import styled from "styled-components";
import LeftLayout from "../../../Components/LeftLayout";
import LanguageComponent from "../../../Components/LangTranslation/LanguageComponent";
import { authRequest } from "../../../authentications/auth";
import { useLanguage } from "../../../Components/LangTranslation/LanguageContext";
import { useSession } from "../../../authentications/SessionContext";
import emailicon from "../../../Images/email.svg";
import passwardicon from "../../../Images/lock.svg";
import { Formik } from "formik";
import SignInSchema from "../../../utilities/Validation Schema/SignInSchema";
import { getToken } from "../../../authentications/getCSRFToken";
import { webLoginApi } from "../../../authentications/webLogin";
import LoaderWrapper from "../../../Components/Loader/LoaderWrapper";
import { Helmet } from "react-helmet-async";

const SignIn = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const loginErrorRef = useRef(null);
  const loginRef = useRef(null);
  const [csrfToken, setCsrfToken] = useState(null);
  const { handleAuthentication, setSessInfo, sessionInfo } = useSession();
  const { isVTEX, VtexAdmin, ionAdmin } = sessionInfo;
  // console.log("ionAdmin", ionAdmin);
  const togglePasswordVisibility = () => {
    setFormData({ ...formData, showPassword: !formData.showPassword });
  };
  const handleForgotPasswordClick = () => {
    navigate("/resetPassword");
  };
  const handleSignUpClick = () => {
    // if (isVTEX) {
    //   navigate("/signup-info");
    // } else {
    navigate("/signup");
    // }
  };

  // console.log(VtexAdmin, ionAdmin, isVTEX, "VtexAdmin,ionAdmin,isVTEX");
  const handleSubmit = async (e) => {
    e.preventDefault();
    loginRef.current.disabled = true;
    setIsLoading(true);

    const { email, password } = formData;

    try {
      await webLoginApi(email, password, csrfToken);
      const result = await authRequest(email, password);
      if (result.success) {
        // console.log("authentication result", result);
        setSessInfo(
          result.company_id,
          result.user_id,
          result.context,
          result.name,
          result.username,
          result.user_companies,
          result.suspended_merchant || false,
          result.company_partner_id,
          result.is_admin,
          result.is_vtex_admin,
          result.is_vtex_omantal,
          sessionInfo.isVTEX
        );
        handleAuthentication(true);
        localStorage.setItem("authenticated", JSON.stringify(true));
        loginErrorRef.current.classList.add("d-none");
        const returnPath = location.state?.from;
        if (returnPath) {
          navigate(returnPath, { replace: true });
          return;
        }
        if (
          !window?.location?.port &&
          result?.merchant_domain &&
          window?.location?.origin !== result?.merchant_domain
        ) {
          const signinPath = result?.merchant_domain.includes("/merchant")
            ? `${result?.merchant_domain}/signin`
            : `${result?.merchant_domain}/merchant/signin`;

          window.location.href = signinPath;
          return;
        }
      } else {
        localStorage.setItem("authenticated", JSON.stringify(false));
        loginErrorRef.current.classList.remove("d-none");
        loginErrorRef.current.textContent = "Wrong login/password";
      }
    } catch (error) {
      console.error("An error occurred:", error);
      loginErrorRef.current.classList.remove("d-none");
      loginErrorRef.current.textContent =
        "An error occurred while authenticating";
    } finally {
      loginRef.current.disabled = false;
      setIsLoading(false);
    }
  };
  const callCSRFApi = async () => {
    try {
      const result = await getToken();
      if (result.success) {
        setCsrfToken(result.token);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  useEffect(() => {
    callCSRFApi();
  }, []);

  return (
    <LoaderWrapper isLoading={!csrfToken} height="100vh" width="100vw">
      <Helmet>
        <title>Sign-In | iON Merchant Portal</title>
        <meta name="Sign-In" />
      </Helmet>
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={SignInSchema}
        onSubmit={handleSubmit}
      >
        <SigninSplit>
          <LeftLayout />
          <div style={{ position: "absolute", top: 10, right: 10 }}>
            <LanguageComponent />
          </div>

          <FormContainer onSubmit={handleSubmit}>
            <Title>{t["Sign In"]}</Title>
            <LoginText>{t["Welcome Back You have been missed!"]}</LoginText>
            <EmailInputDiv>
              <Icon className="emailicon">
                <img src={emailicon} alt="emailIcon" />
              </Icon>
              <InputField
                type="text"
                name="email"
                value={formData.email}
                placeholder={t["Your Email"]}
                onChange={handleInputChange}
                onBlur={handleInputChange}
                className="login_signup_inputs"
              />
            </EmailInputDiv>
            <Inputs>
              <div className="password-input">
                <PasswordIcon className="passicon">
                  <img src={passwardicon} alt="emailIcon" />
                </PasswordIcon>
                <InputField
                  type={formData.showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  placeholder={t["Create Password"]}
                  onChange={handleInputChange}
                  className="passInput"
                />
                <span
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {formData?.showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
                <div
                  className="forget_password"
                  onClick={handleForgotPasswordClick}
                >
                  <span>{t["Forget Password"]}</span>
                </div>
              </div>
            </Inputs>
            <ErrorDiv
              ref={loginErrorRef}
              className="loginError  d-none col-12 alert alert-danger"
              role="alert"
            ></ErrorDiv>
            <LoginButton
              ref={loginRef}
              disabled={isLoading || !csrfToken}
              type="submit"
              data-isvtex={isVTEX}
              className="d-flex align-items-center justify-content-center"
            >
              {isLoading ? (
                <div className="spinner-border mx-2" role="status"></div>
              ) : (
                ""
              )}
              {!csrfToken ? (
                <span>{t["Please Wait"]}</span>
              ) : (
                <span>{`${t["Sign In"]}`}</span>
              )}
            </LoginButton>

            <div className="last_sec_signUp">
              {t["Don't have an account yet?"]}{" "}
              <SignUpText onClick={handleSignUpClick}>
                {t["Sign Up"]}
              </SignUpText>
            </div>
          </FormContainer>
        </SigninSplit>
      </Formik>
    </LoaderWrapper>
  );
};

export default SignIn;

// styled-components

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 100px;
  width: 50%;
  padding: 33px;

  @media only screen and (max-width: 768px) {
    padding: 18px;
    width: 100%;
    .last_sec_signUp {
      font-size: 10px;
      font-weight: 500;
      text-align: center;
    }
  }
  .last_sec_signUp {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 500;
  }
`;

const Title = styled.label`
  font-weight: 700;
  font-size: 32px;
  font-family: "Inter", sans-serif;

  @media only screen and (max-width: 1024px) {
    font-size: 26px;
  }
`;

const SigninSplit = styled.div`
  display: flex;
`;

const LoginText = styled.label`
  color: #4e5d78;
  font-weight: 500;
  font-size: 17px;
  font-family: "Inter", sans-serif;
  margin: 20px 0;

  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const Icon = styled.div`
  position: absolute;
  top: 36%;
  left: 10px;
  transform: translateY(-50%);
  color: #cbcbcb;
`;

const PasswordIcon = styled.div`
  position: absolute;
  top: 54%;
  left: 10px;
  transform: translateY(-50%);
  color: #cbcbcb;
`;

const LoginButton = styled.button`
  width: 100%;
  max-width: 518px;
  height: 60px;
  border-radius: 14px;
  font-family: "Comfortaa", sans-serif;
  background-color: #ff5837;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  font-weight: 600;
  border-width: 0;
  margin-top: 65px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

const ErrorDiv = styled.div`
  width: 100%;
  max-width: 518px;
  margin-top: 60px;
`;

const EmailInputDiv = styled.div`
  position: relative;
  .login_signup_inputs {
    width: 100%;
    max-width: 518px;
    height: 58px;
    padding-left: 40px;
    border-radius: 16px;
    box-shadow: 0 2px 4px 0 #cbcbcb;
    background: #f5f5f5;
    border-width: 0;
    margin-bottom: 20px;
    &:focus {
      border: 2px solid #ff5837;
      outline: none;
    }
  }

  .invalid-input {
    border-color: #ff0000;
  }

  .error-message {
    color: #ff0000;
  }
`;

const Inputs = styled.div`
  .forget_password {
    height: 20px;
    color: #4e5d78;
    margin-top: 10px;
    font-size: 14px;
    font-family: "Montserrat";
    font-weight: 600;
    display: flex;
    justify-content: end;
    align-items: center;
    cursor: pointer;
  }
  .forget_password:hover {
    color: #ff5837;
  }
  .password-input {
    position: relative;
    width: 100%;
    max-width: 518px;
    height: 58px;
  }

  .passInput {
    width: 100%;
    height: inherit;
    border-radius: 14px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    background: #f5f5f5;
    border-width: 0;
    padding-left: 40px;
    margin-bottom: 10px;
    &:focus {
      border: 2px solid #ff5837;
      outline: none;
    }
  }
  .password-toggle {
    position: absolute !important;
    top: 32% !important;
    right: 10px !important;
    align-items: center !important;
    cursor: pointer !important;
    color: #cbcbcb !important;
    height: 15px !important;
    width: 22px !important;
  }
`;

const SignUpText = styled.span`
  color: #ff5837;
  font-weight: 500;
  cursor: pointer;
`;
